module.exports = __webpack_public_path__ + "img/d-p-04.b2c10971.png";